import React from "react";
import {
  Dialog,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import PolicyImg from "../utils/images/policy.svg";

const PolicySelectionDialog = ({
  open,
  onClose,
  policies,
  selectedPolicyId,
  onPolicyChange,
}) => {

  const selectedPolicy = policies.find(
    (policy) => policy?.entityPolicyId == selectedPolicyId
  );
  const otherPolicies = policies.filter(
    (policy) => policy?.entityPolicyId != selectedPolicyId
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          margin: 0,
          borderRadius: "24px 24px 0 0",
          maxHeight: "70vh",
          width: "100%",
        },
      }}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-end",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <Box sx={{ padding: "20px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
            paddingBottom: "16px",
            borderBottom: "1px solid #E5E7EB",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <img src={PolicyImg} alt="Policy" height={24} width={24} />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: "18px",
                color: "#252D38",
                margin: 0,
              }}
            >
              Switch Policy
            </Typography>
          </Box>
          <IconButton onClick={onClose} sx={{ padding: "4px" }}>
            <CloseIcon sx={{ color: "#47566A", fontSize: "24px" }} />
          </IconButton>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          {selectedPolicy && (
            <Box
              onClick={() => onPolicyChange(selectedPolicy?.entityPolicyId)}
              sx={{
                padding: "16px",
                borderRadius: "12px",
                backgroundColor: "#F1F7FF",
                border: "1.5px solid #0066DC",
                cursor: "pointer",
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
                "&:hover": {
                  backgroundColor: "#F1F7FF",
                },
                "&:active": {
                  transform: "scale(0.98)",
                },
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#252D38",
                    lineHeight: "22px",
                  }}
                >
                  {selectedPolicy?.policyPeriodLabel ??
                    selectedPolicy?.policyName}
                </Typography>
                {selectedPolicy?.policyDescription && (
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: 400,
                      color: "#6B7280",
                      lineHeight: "18px",
                      marginTop: "4px",
                    }}
                  >
                    {selectedPolicy?.policyDescription}
                  </Typography>
                )}
              </Box>

              <CheckCircleIcon
                sx={{
                  color: "#0066DC",
                  fontSize: "24px",
                  flexShrink: 0,
                }}
              />
            </Box>
          )}
          {otherPolicies.length > 0 && (
            <>
              <Box
                sx={{
                  borderBottom: "1px solid #E5E7EB",
                  marginTop: "8px",
                }}
              />
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#252D38",
                  marginTop: "8px",
                  marginBottom: "4px",
                }}
              >
                Switch To
              </Typography>

              {otherPolicies.map((policy) => (
                <Box
                  key={policy?.entityPolicyId}
                  onClick={() => onPolicyChange(policy?.entityPolicyId)}
                  sx={{
                    padding: "16px",
                    borderRadius: "12px",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #E5E7EB",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                    "&:hover": {
                      backgroundColor: "#F9FAFB",
                    },
                    "&:active": {
                      transform: "scale(0.98)",
                    },
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontSize: "15px",
                        fontWeight: 400,
                        color: "#252D38",
                        lineHeight: "22px",
                      }}
                    >
                      {policy?.policyPeriodLabel ?? policy?.policyName}
                    </Typography>
                    {policy?.policyDescription && (
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 400,
                          color: "#6B7280",
                          lineHeight: "18px",
                          marginTop: "4px",
                        }}
                      >
                        {policy?.policyDescription}
                      </Typography>
                    )}
                  </Box>

                  <RadioButtonUncheckedIcon
                    sx={{
                      color: "#0066DC",
                      fontSize: "24px",
                      flexShrink: 0,
                    }}
                  />
                </Box>
              ))}
            </>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default PolicySelectionDialog;